import React, {ReactNode} from "react";
import "./FCTooltip.scss"

type TooltipProps = {
    children: ReactNode;
    top?: number;
    left?: number;
    visible?: boolean;
};

const FCTooltip: React.FunctionComponent<TooltipProps> = (props: TooltipProps) => {
    const posStyle: React.CSSProperties = props.top !== undefined
        ? {position: "fixed", top: props.top, left: props.left}
        : {};

    return (
        <span className={`tooltiptext${props.visible ? " tooltipVisible" : ""}`} style={posStyle}>
            {props.children}
        </span>
    );
}

export default FCTooltip;
